import React, {Component} from 'react';
import { withStyles } from '@material-ui/core/styles';
import CheckIcon from '@material-ui/icons/Check';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import CloseIcon from '@material-ui/icons/Close';
import Button from '@material-ui/core/Button';
import './StaticPageCheck.css'


const wStyles = theme => ({
    textLink:{     
        height:40,
        color:"white",
        fontFamily:"Microsoft JhengHei",
        borderStyle:"soild",
        borderWidth:1,
        borderColor:"black",
        backgroundColor:"#2783c4",
        textAlign:"center",
        fontSize:20,
        lineHeight:"30px",
        margin:"auto",
        '&:hover':{
            color:"black",
        },
    },
    eventEditCompleteFieldTimeInput:{
        border: "1px solid",
        padding: "10px",
        borderRadius: "5px",
        backgroundColor: "#ffffff"
    },
    mainIconCheckFalse:{
        width:"5em",
        height:"5em",
        color:"#ff0000"
    },
    mainIconCheckTrue:{
        width:"5em",
        height:"5em",
        color:"#0080ff"
    },
    iconCheckFalse:{
        width:"2em",
        height:"2em",
        color:"#ff0000"
    },
    iconCheckTrue:{
        width:"2em",
        height:"2em",
        color:"#0080ff"
    }
})

class StaticPageCheck extends Component {
    constructor(props) {
        super(props)
        this.state = {
            checkReport:null
        }
    }

    componentDidMount(){
        this.getAwaitProps()
    }

    componentDidUpdate(){
   
    }

    componentWillUnmount(){

    }

    getAwaitProps=async()=>{
        let temp = await this.props.fieldCheck
        console.log("StaticPageCheck")
        console.log(temp)
        this.setState({
            checkReport:temp
        })
    }

    checkUpdateOrNot=()=>{
        let checkResult = true
        if(this.state.checkReport)
        {
            for(let key in this.state.checkReport)
            {
                let checkReport = this.state.checkReport[key]
                for(let subKey in checkReport)
                {
                    if(!checkReport[subKey])
                    {
                        checkResult = false
                    }
                }
            }
        }
        else
        {
            checkResult = false
        }
        return checkResult
    }

    render(){
        const {classes} = this.props;

        let scrollContainer={
            position:"relative",
            width:"100%",
            height:"100%",
            backgroundColor:"#9a9999",
        }

        let eventEditCompleteFieldSysID = {
            border: "1px solid",
            padding: "10px",
            borderRadius: "5px",
            backgroundColor: "#ffffff",
            fontSize:"17px",
            lineHeight:"80px",
            width:"70%"
        }

        let checkIconStyle = {
            border: "1px solid",
            borderRadius: "5px",
            lineHeight:"0px",
            textAlign:"center",
            fontFamily:""
        }

        let createFirstStageOptionCheckReport =()=>{
            let mainCheck = true
        
            if(this.state.checkReport)
            {
                let temp = this.state.checkReport.firstStageOptionCheck
                Object.keys(temp).forEach(key=>{
                    if(!temp[key])
                    {
                        mainCheck = false
                    }
                })
            }
       
            if(this.state.checkReport)
            {
                if(mainCheck)
                {
                    return <div style={eventEditCompleteFieldSysID}><div style={checkIconStyle}><CheckIcon className={classes.mainIconCheckTrue}/></div></div>
                }
                else
                {
                    if(this.state.checkReport.firstStageOptionCheck.OptionEmptyCheck)
                    {
                        return <div style={eventEditCompleteFieldSysID}><div style={checkIconStyle}><CloseIcon className={classes.mainIconCheckFalse}/></div><div><p>請檢查</p><p><CheckIcon className={classes.iconCheckTrue}/>1. 至少有1個第一階選項</p><p>{this.state.checkReport.firstStageOptionCheck.RouteDeafultCheck? <CheckIcon className={classes.iconCheckTrue}/>:<CloseIcon className={classes.iconCheckFalse}/>}2. 選項路徑非預設值</p><p>{this.state.checkReport.firstStageOptionCheck.RouteUniqueCheck? <CheckIcon className={classes.iconCheckTrue}/>:<CloseIcon className={classes.iconCheckFalse}/>}3. 選項路徑不能重複</p><p>{this.state.checkReport.firstStageOptionCheck.TitleDeafultCheck? <CheckIcon className={classes.iconCheckTrue}/>:<CloseIcon className={classes.iconCheckFalse}/>}4. 選項標題非預設值</p><p>{this.state.checkReport.firstStageOptionCheck.TitleUniqueCheck? <CheckIcon className={classes.iconCheckTrue}/>:<CloseIcon className={classes.iconCheckFalse}/>}5. 選項標題不能重複</p></div></div>
                    }
                    else
                    {
                        return <div style={eventEditCompleteFieldSysID}><div style={checkIconStyle}><CloseIcon className={classes.mainIconCheckFalse}/></div><div><p>請檢查</p><p><CloseIcon className={classes.iconCheckFalse}/>1. 至少有1個第一階選項</p></div></div>
                    }
                }
            }
            else
            {
                return null
            }
        }

        let createSecondStageOptionCheckReport =()=>{
            let mainCheck = true
        
           if(this.state.checkReport)
            {
                let temp = this.state.checkReport.secondStageOptionCheck
                Object.keys(temp).forEach(key=>{
                    if(!temp[key])
                    {
                        mainCheck = false
                    }
                })
            }
       
            if(this.state.checkReport)
            {
                if(mainCheck)
                {
                    return <div style={eventEditCompleteFieldSysID}><div style={checkIconStyle}><CheckIcon className={classes.mainIconCheckTrue}/></div></div>
                }
                else
                {
                    if(this.state.checkReport.secondStageOptionCheck.SecondOptionEmptyCheck)
                    {
                        return <div style={eventEditCompleteFieldSysID}><div style={checkIconStyle}><CloseIcon className={classes.mainIconCheckFalse}/></div><div><p>請檢查</p><p><CheckIcon className={classes.iconCheckTrue}/>1. 每一個第1階選項下至少有1個第2階選項</p><p>{this.state.checkReport.secondStageOptionCheck.SecondOptionRouteDeafultCheck? <CheckIcon className={classes.iconCheckTrue}/>:<CloseIcon className={classes.iconCheckFalse}/>}2. 選項路徑非預設值</p><p>{this.state.checkReport.secondStageOptionCheck.SecondOptionRouteUniqueCheck? <CheckIcon className={classes.iconCheckTrue}/>:<CloseIcon className={classes.iconCheckFalse}/>}3. 選項路徑不能重複</p><p>{this.state.checkReport.secondStageOptionCheck.SecondOptionTitleDeafultCheck? <CheckIcon className={classes.iconCheckTrue}/>:<CloseIcon className={classes.iconCheckFalse}/>}4. 選項標題非預設值</p><p>{this.state.checkReport.secondStageOptionCheck.SecondOptionTitleUniqueCheck? <CheckIcon className={classes.iconCheckTrue}/>:<CloseIcon className={classes.iconCheckFalse}/>}5. 選項標題不能重複</p></div></div>
                    }
                    else
                    {
                        return <div style={eventEditCompleteFieldSysID}><div style={checkIconStyle}><CloseIcon className={classes.mainIconCheckFalse}/></div><div><p>請檢查</p><p><CloseIcon className={classes.iconCheckFalse}/>1. 每一個第1階選項下至少有1個第2階選項</p></div></div>
                    }
                }
            }
            else
            {
                return null
            }
        }

        let createStaticPageCheckReport =()=>{
            let mainCheck = true
        
           if(this.state.checkReport)
            {
                let temp = this.state.checkReport.stagePageCheck
                Object.keys(temp).forEach(key=>{
                    if(!temp[key])
                    {
                        mainCheck = false
                    }
                })
            }
       
            if(this.state.checkReport)
            {
                if(mainCheck)
                {
                    return <div style={eventEditCompleteFieldSysID}><div style={checkIconStyle}><CheckIcon className={classes.mainIconCheckTrue}/></div></div>
                }
                else
                {
                    if(this.state.checkReport.stagePageCheck.CompositionEmptyCheck)
                    {
                        return <div style={eventEditCompleteFieldSysID}><div style={checkIconStyle}><CloseIcon className={classes.mainIconCheckFalse}/></div><div><p>請檢查</p><p><CheckIcon className={classes.iconCheckTrue}/>1. 有設定1個以上內容區塊</p><p>{this.state.checkReport.stagePageCheck.ImageDivCheck? <CheckIcon className={classes.iconCheckTrue}/>:<CloseIcon className={classes.iconCheckFalse}/>}2. 影像區塊都有上傳影像</p><p>{this.state.checkReport.stagePageCheck.TextDivCheck? <CheckIcon className={classes.iconCheckTrue}/>:<CloseIcon className={classes.iconCheckFalse}/>}3. 文字區塊有填寫文字並且有儲存(非預設值)</p></div></div>
                    }
                    else
                    {
                        return <div style={eventEditCompleteFieldSysID}><div style={checkIconStyle}><CloseIcon className={classes.mainIconCheckFalse}/></div><div><p>請檢查</p><p><CloseIcon className={classes.iconCheckFalse}/>1. 有設定1個以上內容區塊</p></div></div>
                    }
                }
            }
            else
            {
                return null
            }
        }

        return (

            <div style={scrollContainer} >
                <div style={{display:"flex"}}>
                    <div className={"staticPageCheckMainTitleContainer"}>
                        <div className={"staticPageCheckMainTitle"}>靜態頁面正式發布前檢查</div>
                    </div>
                </div>
                <div style={{display:"flex", margin:"10px"}}>
                    <div className={"staticPageCheckFieldGroup"}>
                        <div className={"staticPageCheckFieldTitle"}>第一階選項檢查</div>
                        {createFirstStageOptionCheckReport()}
                    </div>
                    <div className={"staticPageCheckFieldGroup"}>
                        <div className={"staticPageCheckFieldTitle"}>第二階選項檢查</div>
                        {createSecondStageOptionCheckReport()}
                    </div>
                    <div className={"staticPageCheckFieldGroup"}>
                        <div className={"staticPageCheckFieldTitle"}>靜態頁面檢查</div>
                        {createStaticPageCheckReport()}
                    </div>
                </div>
                {this.checkUpdateOrNot()?<div className={"staticPageCheckWarningContainer"}>{"已對靜態頁面進行上述基本檢查，皆通過，可發布為正式頁面。"}<mark style={{color:"red",fontWeight:"bold"}}>{"請注意，若發布將取代目前靜態頁面。"}</mark></div>:null}
                <div style={{display:"flex"}}>
                    <Button className={classes.textLink} startIcon={<ArrowBackIcon/>} onClick={()=>{this.props.closeModal()}}>
                        {'回編輯頁面'}
                    </Button>
                    {this.checkUpdateOrNot()? 
                        <Button className={classes.textLink} startIcon={<CheckIcon/>} onClick={()=>{this.props.updateDB()}}>
                            {'發布為正式頁面'}
                        </Button>
                        :null
                    }
                </div>
            </div>     
        )  
    }
}

export default withStyles(wStyles)(StaticPageCheck)